const callbacks = []

export function registerReady(callback: () => void): void {
  callbacks.push(callback)
}

export default function ready(): void {
  callbacks.forEach(callback => {
    callback()
  })
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/bridge/ready.ts